import React from 'react';
import {ParagraphPostFBComponentProps} from "@/components/paragraphs/types";
import {cn} from "@/lib/utils";

const ParagraphPostFB = ({node, className, ...props} : ParagraphPostFBComponentProps) => {

    const iframeHeight = node.field_hauteur ? node.field_hauteur.toString() : "500";

    return (
        <div className={
            cn(
                "",
                className
            )}
             {...props}
        >
            {node.field_url_iframe  && (
                <iframe className="w-full" height={iframeHeight} src={node.field_url_iframe.uri} style={{border:'none', overflow:'hidden'}} allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            )}
        </div>
    );
};

export default ParagraphPostFB;